var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse4, _ellipse5, _ellipse6, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 215,
    viewBox: "0 0 580 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 214.613L0 143.056H1.00867C40.5287 143.056 72.5661 175.093 72.5661 214.613V214.613H0Z",
    fill: "#5DCC97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5659 71.5566V143.114H71.5572C32.0372 143.114 -0.000160217 111.077 -0.000160217 71.5566V71.5566H72.5659Z",
    fill: "#3A70F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.264 0V71.5574H289.255C249.735 71.5574 217.698 39.5201 217.698 0V0L290.264 0Z",
    fill: "#5DCC97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.698 71.5566V143.114H216.69C177.17 143.114 145.132 111.077 145.132 71.5566V71.5566H217.698Z",
    fill: "#5DCC97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.264 143.336V214.893H289.255C249.735 214.893 217.698 182.856 217.698 143.336V143.336H290.264Z",
    fill: "#5DCC97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5659 71.5566V143.114H73.5746C113.095 143.114 145.132 111.077 145.132 71.5566V71.5566H72.5659Z",
    fill: "#FFED29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.811 214.855V143.298H73.8197C113.34 143.298 145.377 175.335 145.377 214.855V214.855H72.811Z",
    fill: "#FFED29"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.415,
    cy: 178.893,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 181.415 178.893)",
    fill: "#3A70F6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.283,
    cy: 35.7779,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 36.283 35.7779)",
    fill: "#5DCC97"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.981,
    cy: 107.446,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 253.981 107.446)",
    fill: "#FFED29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.869 32.7043C217.869 54.2158 200.148 71.6543 178.288 71.6543H72.434V39.1959C72.434 17.6845 90.1552 0.245956 112.015 0.245956H217.869V32.7043Z",
    fill: "#3A70F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.736 214.613V143.056H290.745C330.265 143.056 362.302 175.093 362.302 214.613V214.613H289.736Z",
    fill: "#5DCC97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M362.302 71.5566V143.114H361.293C321.773 143.114 289.736 111.077 289.736 71.5566V71.5566H362.302Z",
    fill: "#3A70F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M580 0V71.5574H578.991C539.471 71.5574 507.434 39.5201 507.434 0V0L580 0Z",
    fill: "#5DCC97"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M507.434 71.5566V143.114H506.425C466.905 143.114 434.868 111.077 434.868 71.5566V71.5566H507.434Z",
    fill: "#5DCC97"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M580 143.336V214.893H578.991C539.471 214.893 507.434 182.856 507.434 143.336V143.336H580Z",
    fill: "#5DCC97"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M362.302 71.5566V143.114H363.31C402.83 143.114 434.868 111.077 434.868 71.5566V71.5566H362.302Z",
    fill: "#FFED29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M362.547 214.855V143.298H363.556C403.076 143.298 435.113 175.335 435.113 214.855V214.855H362.547Z",
    fill: "#FFED29"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.151,
    cy: 178.893,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 471.151 178.893)",
    fill: "#3A70F6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.019,
    cy: 35.7779,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 326.019 35.7779)",
    fill: "#FFED29"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.717,
    cy: 107.446,
    rx: 35.7787,
    ry: 36.283,
    transform: "rotate(-90 543.717 107.446)",
    fill: "#FFED29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M507.605 32.7043C507.605 54.2158 489.884 71.6543 468.024 71.6543H362.17V39.1959C362.17 17.6845 379.892 0.245956 401.752 0.245956H507.605V32.7043Z",
    fill: "#3A70F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHeader);
export default __webpack_public_path__ + "static/media/edit-header.5b5511c4a3ef02f90002082dd80a9a38.svg";
export { ForwardRef as ReactComponent };